var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"myBreadcrumb",staticClass:"my-breadcrumb"},_vm._l((_vm.items),function(item,i){return _c('b-link',{key:i,attrs:{"to":item.url}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }